import { render, staticRenderFns } from "./BonusReportTable.vue?vue&type=template&id=4f45fa3c&scoped=true&"
import script from "./BonusReportTable.vue?vue&type=script&lang=js&"
export * from "./BonusReportTable.vue?vue&type=script&lang=js&"
import style0 from "./BonusReportTable.vue?vue&type=style&index=0&id=4f45fa3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45fa3c",
  null
  
)

export default component.exports